export default __webpack_public_path__ + "static/media/find_magnifier_circle.99a5016b.png";